module.exports = __webpack_public_path__ + "media/images/icons/outlined/cluster-45fc6dc4f9e1b1efec109d5a16115ba6.svg";